<template>
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <!-- Container wrapper -->
        <div class="container-fluid">
            <!-- Toggle button -->
            <button data-mdb-collapse-init class="navbar-toggler" type="button"
                data-mdb-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <i class="fas fa-bars"></i>
            </button>

            <!-- Collapsible wrapper -->
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <!-- Navbar brand -->
                <a class="navbar-brand mt-2 mt-lg-0" href="#">
                    <img src="BEAU VOYAGE LOGOTIPO_Mesa de trabajo 1 copia.png" height="55" alt="BEAU VOYAGE LOGOTIPO"
                        loading="lazy" />
                </a>
                <!-- Left links -->
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <RouterLink to="/Dashboard" class="nav-link" active-class="active">Inicio</RouterLink>
                    </li>
                    <li class="nav-item">
                        <RouterLink to="/Reservations" class="nav-link" active-class="active">Reservaciones</RouterLink>
                    </li>
                    <li class="nav-item">
                        <RouterLink to="/MesaDeRegaloAlta" class="nav-link" active-class="active">Registrar mesa de regalos</RouterLink>
                    </li>
                    <li class="nav-item">
                        <RouterLink to="/MisMesas" class="nav-link" active-class="active">Mi mesa de regalos</RouterLink>
                    </li>
                    <li class="nav-item">
                        <RouterLink to="/paquetesDash" class="nav-link" active-class="active">Paquetes</RouterLink>
                    </li>
                   
                </ul>
                <!-- Left links -->
            </div>
            <!-- Collapsible wrapper -->

            <!-- Right elements -->
            <div class="d-flex align-items-center">
                <!-- Notifications -->
               
                <!-- Avatar -->
                <div class="dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <i class="fa-regular fa-circle-user"></i>
                        <span class="ml-2 px-1">{{ nombre }}</span>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuAvatar">
                        <li>
                            <a class="dropdown-item" href="/Porfile">Mi perfil</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="#" @click="logout">Cerrar sesión</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Right elements -->
        </div>
        <!-- Container wrapper -->
    </nav>
    <!-- Navbar -->
</template>
<script>
import axios from "axios";
export default {
    name: "NvarDash",
    data() {
        return {
            nombre: "Cargando...",
        };
    },
    methods: {
        logout() {
            localStorage.removeItem("token")
            this.$router.push("/login")
        },
        changeTheme() {
            this.$emit("update-estadoDash", {
                isActive: false,
                isActive2: false,
                isActive3: false,
            });
        },
        async getDataUser() {
            const token = localStorage.getItem("token")
            try {
                const response = await axios.get("https://beauvoyage.net/api/v1/auth/me", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                this.nombre = response.data.name;
            } catch (error) {
                localStorage.removeItem("token")
                this.$router.push("/login")
            }
        }
    },
    created() {
        this.changeTheme()
        this.getDataUser()
    }

};
</script>